/*TODO this is a stack? */
.root {
  display: flex;
  flex-direction: column;
  align-items: center;

  .species {
    display: flex;
    flex-direction: column;

    .common {
      color: blue;
    }

    .scientific {
      color: darkgray;
    }
  }

  /* TODO: copied from calendar.module.css */
  .bingo_cal {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    column-gap: 10px;
    row-gap: 15px;
    max-width: 80vw;
  }

  /* TODO: Cleanup the calendar usage */
  .month .count {
    color: gray;
    font-weight: normal;
  }
  .day {
    width: 25px;
    height: 25px;
    text-align: center;
    border-radius: 50%;

    &>a {
      text-decoration: none;
      color: black;
    }
    &[data-seen="true"] {
      background-color: rgb(247, 165, 120);
      /* background-color: #69db7c; */
    }
  }
}

